import { Text } from '@wartek-id/text'

import { EmptyState } from '@/components/EmptyState'

export const DiktiPanel = () => {
  return (
    <EmptyState
      customImage="/images/img-empty-document.svg"
      size="sm"
      title="Untuk saat ini data DIKTI belum tersedia."
      description={
        <Text>
          Silahkan kunjungi laman{' '}
          <a
            className="underline"
            href="https://referensi.data.kemdikbud.go.id/pendidikan/dikti?utm_source=portal-satu-data"
            rel="noopener noreferrer"
            target="_blank"
          >
            referensi data ini
          </a>{' '}
          untuk melihat lebih lengkap.
        </Text>
      }
      sectionClassName="bg-gray-5"
    />
  )
}
